import classNames from "classnames";
import React, { ReactElement } from "react";
import Help, { ARTICLES } from "../../../components/help/Help";
import SquareIcon from "../../../components/square-icon/SquareIcon";
import Badge from "../../../components/theme/badge/Badge";
import { useTheme } from "../../../contexts/Theme";
import Styles from "../Onboarding.module.scss";
import { StepProps } from "./base";
import useArticleContext from "../../../contexts/HelpContext";

export default function OnboardingStep(props: StepProps): ReactElement {
    const theme = useTheme();

    useArticleContext(theme.isV3 ? ARTICLES.CONTACTED_PAGE : undefined);
    if (theme.isV3) {
        return (
            <div>
                <div className={Styles["step-header"]}>
                    <h2 className={Styles["step-title"]}>Add Foqal to a Slack Channel.</h2>
                    <p>
                        Here is a quick instruction how to add Foqal Agent to the Channel.
                    </p>
                </div>
                <div className={classNames(Styles["step-content"], Styles["list-with-preview"])}>
                    <div>
                        <div className={Styles["step-content-numbered"]}>
                            <Badge variant="main" size="medium">1</Badge>
                            <div className={Styles["step-content-numbered-description"]}>
                                <h3>Select Your Slack Channel</h3>
                                <p>
                                    Go to your Slack workspace and find the channel in which you want to install Foqal Agent.
                                    If this is the first time you are testing, you may want to
                                    {" "}
                                    <a
                                        href="https://slack.com/help/articles/201402297-Create-a-channel"
                                        target="_blank"
                                        rel="noreferrer"
                                        className="text-decoration-none"
                                    >
                                        create a new test channel
                                    </a>
                                    .
                                </p>
                            </div>
                        </div>
                        <div className={Styles["step-content-numbered"]}>
                            <Badge variant="main" size="medium">2</Badge>
                            <div className={Styles["step-content-numbered-description"]}>
                                <h3>Invite Agent to the Channel</h3>
                                <p>
                                    Type
                                    {" "}
                                    <code>/invite @Agent</code>
                                    {" "}
                                    in the channel and hit  send to invite the Foqal Agent.
                                </p>
                            </div>
                        </div>
                        <div className={Styles["step-content-numbered"]}>
                            <Badge variant="main" size="medium">3</Badge>
                            <div className={Styles["step-content-numbered-description"]}>
                                <h3>Complete the Setup</h3>
                                <p>
                                    Once Foqal Agent is added to the Slack channel, click
                                    {" "}
                                    <code>Finish Setup</code>
                                    {" "}
                                    to complete the process.
                                </p>
                            </div>
                        </div>
                    </div>
                    <div className={Styles["choice-preview"]}>
                        <img
                            src="https://static.foqal.io/agent/agent-invite-rebrand-closer.gif"
                            alt="How to invite agent"
                        />
                    </div>
                </div>

            </div>
        );
    }

    return (
        <div>
            <Help articleId={ARTICLES.ONBOARDING_DONE} />
            <h4 className="mb-3">
                Add Foqal to a Slack Channel.
            </h4>
            <div className="d-flex gap-4 align-items-start">
                <div className="col-6">

                    <img
                        src="https://static.foqal.io/agent/agent-invite-rebrand-closer.gif"
                        className="w-100 rounded shadow"
                        alt="How to invite agent"
                    />
                </div>
                <div className="col">
                    <div>

                        <div className="mt-2">
                            <SquareIcon className="me-2">1</SquareIcon>
                            {" "}
                            Go to your Slack workspace and find the channel in which you want to install Foqal Agent.
                            If this is the first time you are testing, you may want to
                            {" "}
                            <a
                                href="https://slack.com/help/articles/201402297-Create-a-channel"
                                target="_blank"
                                rel="noreferrer"
                                className="text-decoration-none"
                            >
                                create a new test channel
                            </a>
                            .
                        </div>
                        <div className="pt-3">
                            <SquareIcon className="me-2">2</SquareIcon>
                            {" "}
                            Type
                            {" "}
                            <code>/invite @Agent</code>
                            {" "}
                            in the channel and hit send.
                        </div>
                        <div className="pt-3">
                            <SquareIcon className="me-2">3</SquareIcon>
                            {" "}
                            Once you added Agent to a Slack channel, click Finish Setup.
                        </div>
                    </div>
                </div>

            </div>

        </div>
    );
}
